function dismissalKey(workspaceId?: string | null, profileId?: string | null): string {
  return `output:workspace-background-picker:dismissed:${workspaceId || 'unknown'}:${profileId || 'unknown'}`;
}

export const WORKSPACE_BACKGROUND_PICKER_DISMISSED_EVENT =
  'output:internal:workspace-background-picker-dismissed';

export function isWorkspaceBackgroundPickerDismissed(workspaceId?: string | null, profileId?: string | null): boolean {
  if (typeof window === 'undefined') return false;

  try {
    return window.localStorage.getItem(dismissalKey(workspaceId, profileId)) === 'true';
  } catch {
    return false;
  }
}

export function dismissWorkspaceBackgroundPicker(workspaceId?: string | null, profileId?: string | null): void {
  if (typeof window === 'undefined') return;

  try {
    window.localStorage.setItem(dismissalKey(workspaceId, profileId), 'true');
  } catch {
    // Dismissal still applies to the current render when storage is unavailable.
  }
  window.dispatchEvent(new Event(WORKSPACE_BACKGROUND_PICKER_DISMISSED_EVENT));
}
